import { useMemo } from "react";
import type { GetBuildSpinnerFrameType } from "../shared/spin/useGetBuildSpinnerFrame";
import { useBnbSelector } from "../../redux/store";
import { getModelFilterSlideTypes } from "../../utils/typedUtils";
import type { ExtraType } from "../../../../../common-deprecated/types/CommonTypes";
import { getCarImageFromConfig } from "../../../../shared-logic/utils/typedUtils";

const useGetProaceGalleryFrame = (): GetBuildSpinnerFrameType => {
    const modelId = useBnbSelector((state) => state.model.id);
    const { carId = "", selectedOptions = [] } = useBnbSelector((state) => state.modelFilter.filteredGrades[0]);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const modelFilterSlides = useBnbSelector((state) => getModelFilterSlideTypes(state.modelFilter));

    // OG height/width: 450/200
    return useMemo(
        () => ({
            getImage: (width: number, height: number, frame: number): string =>
                getCarImageFromConfig(
                    commonSettings,
                    modelFilterSlides[frame].mode,
                    modelFilterSlides[frame].frame,
                    modelId,
                    carId,
                    {
                        width,
                        height,
                        imageQuality: 75,
                        padding: 0,
                        bgColour: "FFFFFF",
                        scaleMode: 0,
                    },
                    undefined,
                    undefined,
                    undefined,
                    [],
                    selectedOptions as ExtraType[],
                ),
            cacheKey: carId,
            modelFilterSlides,
        }),
        [carId, selectedOptions],
    );
};

export default useGetProaceGalleryFrame;
